const GMAP_KEY_MAPPING = {
    'p-tcd-est:www.thecooldown.com': 'VITE_GMAP_API_KEY_TCD',
};

export default GMAP_KEY_MAPPING;
